import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { StudentsService } from '../../services/students.service';
import { ConnectService } from '../../services/connect.service';
import { Status } from '../../enums/status.model';
import { Student } from 'src/app/models/student.model';
import { MediaObserver } from '@angular/flex-layout';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdsService } from 'src/app/services/cds.service';
import * as _ from 'lodash';
import { AccountsService } from 'src/app/services/accounts.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImportErrorsComponent } from '../import/import-errors/import-errors.component';
import { first, firstValueFrom } from 'rxjs';
import * as globals from '../globals';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSidenav } from '@angular/material/sidenav';
import { AssignmentsService } from 'src/app/services/assignments.service';
import { ConfigurationsService } from 'src/app/services/configurations.service';
import { LoggingService } from '../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-training-list',
  templateUrl: './training-list.component.html',
  styleUrls: ['./training-list.component.scss'],
})

export class TrainingsListComponent implements OnInit {

  constructor(
    private accountService: AccountsService,
    private assignmentService: AssignmentsService,
    private connectService: ConnectService,
    private configurationsService: ConfigurationsService,
    private studentsService: StudentsService,
    private cdsService: CdsService,
    public media: MediaObserver,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
    this.retrieveTrainings(true);
  }

  private retrieveTrainings(showLoadingSpinner: boolean) {
    try {
      if(showLoadingSpinner) { 
        this.loadingSpinner.emit(true);
        setTimeout(() => this.loadingSpinner.emit(true), 1000);
      }

      this.studentsService.getStudentsByClassId(this.class_id).subscribe({
        next: (data) => {
          const selectionStudents = this.selection.selected.map(student => student.id);
          this.clearCheckBoxSelection();

          this.dataSource = new MatTableDataSource(data);
          this.studentsLength = data.length;

          data.forEach(student => selectionStudents.includes(student.id) ? this.selection.select(student) : null);

          if(showLoadingSpinner) { 
            this.loadingSpinner.emit(false);
          }
        },
        error: (e) => {
          this.logger.logException(e);
          
          if(showLoadingSpinner) { 
            this.loadingSpinner.emit(false);
          }
        }
      });
    }
    catch (exception) {
      this.logger.logException(exception);
      if(showLoadingSpinner) { 
        this.loadingSpinner.emit(false);
      }
    }
  }

  private async retrieveTrainingsAsync(showLoadingSpinner: boolean) {
    try {
      if(showLoadingSpinner) { 
        this.loadingSpinner.emit(true);
        setTimeout(() => this.loadingSpinner.emit(true), 1000);
      }

      const data = await firstValueFrom(this.studentsService.getStudentsByClassId(this.class_id));
      
      const selectionStudents = this.selection.selected.map(student => student.id);
      this.clearCheckBoxSelection();

      this.dataSource = new MatTableDataSource(data);
      this.studentsLength = data.length;

      data.forEach(student => selectionStudents.includes(student.id) ? this.selection.select(student) : null);

      if(showLoadingSpinner) { 
        this.loadingSpinner.emit(false);
      }
    }
    catch (exception) {
      this.logger.logException(exception);
      if(showLoadingSpinner) { 
        this.loadingSpinner.emit(false);
      }
    }
  }

  studentAdded(response) {
    this.retrieveTrainings(true);
  }

  studentCancelled(response) {
    this.retrieveTrainings(true);    
  }

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  private async assignTraining(student_data: Student) {
    this.logger.logEvent(`Assign Training clicked - StudentId: ${student_data.id}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(await this.isSameAccountFolderGroup(student_data)) {
        this.loadingSpinner.emit(false);
        return;
      }

      const student = [student_data.id];
      await this.assignResources(student);
      this.updateStudentsStatus();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async assignTrainings() {
    this.logger.logEvent(`Assign Trainings clicked - Count: ${this.getSelectedStudentsIds().length}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(this.isStudentsWithoutUnAssigned()) {
        this.showMessage(globals.unassigned_students);
        this.loadingSpinner.emit(false);
        return;
      }

      if(await this.isStudentsWithSameAccountFolderGroup()) {
        this.loadingSpinner.emit(false);
        return true;
      }

      if(await this.isSameAccountFolderGroups()) {
        this.loadingSpinner.emit(false);
        return true;
      }
      
      const selectedStudents = this.getSelectedStudentsIds();
      await this.assignResources(selectedStudents);
      this.updateStudentsStatus();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async setupTraining(student_data: Student) {
    this.logger.logEvent(`Setup Training clicked - StudentId: ${student_data.id}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      // if(await this.isStudentInUse(student_data)) {
      //   return;
      // }

      if(!await this.isClientCredentials(student_data)) {
        return;
      }

      const student = [student_data];
      await this.setupResources(student);
      this.updateStudentsStatus();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async setupTrainings() {
    this.logger.logEvent(`Setup Trainings clicked - Count: ${this.getSelectedStudentsIds().length}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      // if(this.isMultipleStudentsWithInAccount()) {
      //   this.showMessage(globals.multiple_students);
      //   this.loadingSpinner.emit(false);
      //   return;
      // }

      if(this.isStudentsWithoutAssigned()) {
        this.showMessage(globals.students_assigned);
        this.loadingSpinner.emit(false);
        return;
      }

      if(await this.InUse()) {
        return;
      }

      if(await this.validateSetupTrainings()) {
        return;
      }
      
      const selectedStudents = this.getSelectedStudents();
      await this.setupResources(selectedStudents);
      this.updateStudentsStatus();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async validateSetupTrainings(): Promise<boolean> {
    try {
      if(!await this.isClientCredentialsAll()) {
        return true;
      }

      // if(await this.isStudentsInUse()) {
      //   return true;
      // }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      return false;
    }
  }

  private async cleanupTraining(student_data: Student) {
    this.logger.logEvent(`Cleanup Training clicked - StudentId: ${student_data.id}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    if(!this.isClientCredentials(student_data)) {
      return;
    }

    await this.cleanupResources([student_data]);
    this.updateStudentsStatus();
  }

  private async cleanupTrainings() {
    this.logger.logEvent(`Cleanup Trainings clicked - Count: ${this.getSelectedStudentsIds().length}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(this.IsUnassigned()) {
        return;
      }

      if(!await this.isClientCredentialsAll()) {
        return;
      }

      const selectedStudents = this.getSelectedStudents();
      await this.cleanupResources(selectedStudents);
      this.updateStudentsStatus();
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async startStreaming(student_data: Student) {
    this.logger.logEvent(`Start Streaming - StudentId: ${student_data.id}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(!await this.isClientCredentials(student_data)) {
        return;
      }

      const student = [student_data.id];
      this.runResources(student);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async startStreamings() {
    this.logger.logEvent(`Start Streaming - Count: ${this.getSelectedStudentsIds().length}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(!await this.isClientCredentialsAll()) {
        return;
      }

      if(this.isStudentsWithStreamOn()) {
        this.showMessage(globals.students_stream_on);
        this.loadingSpinner.emit(false);
        return;
      }

      const selectedStudentIds = this.getSelectedStudentsIds();
      this.runResources(selectedStudentIds);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async stopStreaming(student_data: Student) {
    this.logger.logEvent(`Stop Streaming - StudentId: ${student_data.id}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(!await this.isClientCredentials(student_data)) {
        return;
      }

      const student = [student_data.id];
      this.stopResources(student);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async stopStreamings() {
    this.logger.logEvent(`Stop Streaming - Count: ${this.getSelectedStudentsIds().length}`);
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      if(!await this.isClientCredentialsAll()) {
        return;
      }

      if(this.isStudentsWithStreamOff()) {
        this.showMessage(globals.students_stream_off);
        this.loadingSpinner.emit(false);
        return;
      }

      const selectedStudentIds = this.getSelectedStudentsIds();
      this.stopResources(selectedStudentIds);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async assignResources(students: any) {
    this.showMessage(globals.assignProcess_time);
    try {
      await firstValueFrom(this.connectService.assignResources(students));
      setTimeout(() => this.loadingSpinner.emit(false), (10 * 1000));
      setTimeout(() => this.retrieveTrainings(false), 6000);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async setupResources(students: Student[]) {
    this.showMessage(globals.setupProcess_time);

    try {    
      const cdsSetupStudentIds: number[] = [];
      const connectSetupStudentIds: number[] = [];
      
      students.forEach(student_data => {
        if(student_data.status === Status.InUse && (student_data.cds_status === Status.Error || student_data.cds_status === Status.Unassigned)) {
          cdsSetupStudentIds.push(student_data.id);
        }
        else {
          connectSetupStudentIds.push(student_data.id);
        }
      });

      if (cdsSetupStudentIds.length > 0) {
        await firstValueFrom(this.cdsService.setup(cdsSetupStudentIds));
      }
      if (connectSetupStudentIds.length > 0) {
        await firstValueFrom(this.connectService.createResources(connectSetupStudentIds));
      }
      setTimeout(() => this.loadingSpinner.emit(false), (20 * 1000));
      setTimeout(() => this.retrieveTrainings(false), (10 * 1000));
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async cleanupResources(students: Student[]) {
    this.showMessage(globals.cleanupProcess_time);

    try {    
      const cdsCleanupStudentIds: number[] = [];
      const connectCleanupStudentIds: string[] = [];
      
      students.forEach(student_data => {
        if(student_data.status === Status.InUse && student_data.cds_status === Status.InUse) {
          cdsCleanupStudentIds.push(student_data.id);
        }
        else {
          connectCleanupStudentIds.push(`${student_data.id}|${student_data.account_id}`);
        }
      });

      if (cdsCleanupStudentIds.length > 0) {
        await firstValueFrom(this.cdsService.cleanup(cdsCleanupStudentIds));
      }
      if (connectCleanupStudentIds.length > 0) {
        await firstValueFrom(this.connectService.cleanupResources(connectCleanupStudentIds));
      }
      setTimeout(() => this.loadingSpinner.emit(false), (20 * 1000));
      setTimeout(() => this.retrieveTrainings(false), (10 * 1000));
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async runResources(studentIds: any) {
    try {
      await firstValueFrom(this.cdsService.run(studentIds));
      setTimeout(() => this.loadingSpinner.emit(false), (10 * 1000));
      setTimeout(() => this.retrieveTrainings(false), 6000);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async stopResources(studentIds: any) {
    try {
      await firstValueFrom(this.cdsService.stop(studentIds));
      setTimeout(() => this.loadingSpinner.emit(false), (10 * 1000));
      setTimeout(() => this.retrieveTrainings(false), 6000);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async forceDelete(student: Student) {
    this.loadingSpinner.emit(true);
    await this.retrieveTrainingsAsync(false);

    try {
      await firstValueFrom(this.connectService.forceDelete(student.id));
      setTimeout(() => this.retrieveTrainings(true), 6000);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async resetStudentStatus(student: Student) {
    try {
      this.loadingSpinner.emit(true);
      await this.retrieveTrainingsAsync(false);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          studentId: student?.id,
          dialogTitle: globals.RESET_STUDENT,
          description: `${globals.RESET_CONFIRM} ${student?.email_id}?`,
          cautionaryMessage: '',
          okButtonTitle: 'Reset',
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        try {
          const reset_status = await firstValueFrom(this.studentsService.resetStudentStatus(student.id));
          this.logger.logEvent(`Reset Student Status Succesful - StudentId: ${student.id}`);

          this.showMessage(reset_status ? globals.reset_studentStatus_success : globals.reset_studentStatus_failed);
          this.loadingSpinner.emit(false);
          this.retrieveTrainings(true);
        }
        catch (exception) {
          this.logger.logException(exception);
          this.showMessage(globals.reset_studentStatus_failed);
          this.loadingSpinner.emit(false);
        }
      }
      else {
        this.loadingSpinner.emit(false);
      }
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  private async confirmDelete(student: Student) {
    try {
      this.logger.logEvent(`Delete Student clicked - StudentId: ${student.id}`);
      this.loadingSpinner.emit(true);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          studentId: student?.id,
          dialogTitle: 'Delete Student',
          description: `${globals.DELETE_WARN} ${student?.email_id}?`,
          cautionaryMessage: '',
          okButtonTitle: globals.DELETE,
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        try {
          await firstValueFrom(this.studentsService.delete_student(student.id));
          this.showMessage(globals.studentDelete_success);
          this.retrieveTrainings(true);
          this.loadingSpinner.emit(false);
        }
        catch (exception) {
          this.logger.logException(exception);
          this.showMessage(globals.studentDelete_fail);
          this.loadingSpinner.emit(false);
        }
      }
      else {
        this.loadingSpinner.emit(false);
      }
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  private updateStudentsStatus() {
    let counter = 0;

    const timer = setInterval(() => {
      this.retrieveTrainings(false);
      
      const student = this.dataSource.data.find((student) => this.isView(student));

      if(student === undefined && counter > 3){
          clearInterval(timer);
      }
      
      counter += 1;
    }, 30000);
  }

  private clearCheckBoxSelection = () => (this.selection.clear());

  private viewProcessErrors(studentId: number) {
    this.dialogRef = this.dialog.open(ImportErrorsComponent, {
      data: {
        studentId: studentId
      },
      width: '800px'
    });
    return firstValueFrom(this.dialogRef.afterClosed()
      .pipe(first()));
  }

  private isMultipleStudentsWithInAccount(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const results = _.groupBy(selectedStudents, i => i.account_id);
    const filteredStudents = _.filter(results, (result) => result.length > 1);

    return (filteredStudents.length > 0);
  }

  private isStudentsWithoutUnAssigned(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const studentsWithoutUnAssigned = _.filter(selectedStudents, 
      (student: Student) => student?.status !== Status.Unassigned && student?.status !== Status.ErrorAssign);

    return (studentsWithoutUnAssigned.length > 0);
  }

  private isStudentsWithoutAssigned(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const studentsWithoutAssigned = _.filter(selectedStudents, 
      (student: Student) => student?.status !== Status.Assigned && student?.status !== Status.Error);

    const studentsWithConnectStatus = _.filter(selectedStudents,
      (student: Student) => student?.status === Status.InUse && (student?.cds_status === Status.Unassigned || student?.cds_status === Status.Error)
    );

    const _studentsWithoutAssigned = (studentsWithoutAssigned.length - studentsWithConnectStatus.length);

    return (_studentsWithoutAssigned > 0);
  }

  private isStudentsWithStreamOn(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const studentsWithStreamOn = _.filter(selectedStudents, (student: Student) => student?.stream_status === Status.On);

    return (studentsWithStreamOn.length > 0);
  }

  private isStudentsWithStreamOff(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const studentsWithStreamOff = _.filter(selectedStudents, (student: Student) => student?.stream_status === Status.Off);

    return (studentsWithStreamOff.length > 0);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  private isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  private masterToggle = () => {
    this.isAllSelected() ? 
      this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  };

  private getSelectedStudentsIds(): number[] {
    const selectedStudents = this.getSelectedStudents();
    const selectedStudentsIds: number[] = JSON.parse(JSON.stringify(selectedStudents.map(student => student.id)));
    _.orderBy(selectedStudentsIds, 0, 'asc');

    return selectedStudentsIds;
  }

  private async isClientCredentials(student: Student): Promise<boolean> {
    try {
      const clientCredentials = await firstValueFrom(this.assignmentService.getAssignmentGuid(student.account_id));

      if([null,undefined,''].includes(clientCredentials?.client_id) || [null,undefined,''].includes(clientCredentials?.client_secret)) {
        this.showMessage(`${globals.clientCredentials_notFound} - ${student.account_name}`);
        this.loadingSpinner.emit(false);
        return false;
      }

      return true;
    }
    catch (exception) {
      this.logger.logException(exception);
      return false;
    }
  }

  private async isClientCredentialsAll(): Promise<boolean> {
    try {
      const studentIds = this.getSelectedStudentsIds();
      const assignments = await firstValueFrom(this.assignmentService.getAssignmentsInValid(studentIds));

      if(assignments?.length > 0) {
        const accounts = assignments.map(assign => assign.name).join();
        this.showMessage(`${globals.clientCredentials_notFound} - ${accounts}`);
        this.loadingSpinner.emit(false);
        return false;
      }

      return true;
    }
    catch ( exception ) {
      this.logger.logException(exception);
      return false;
    }
  }

  private async isStudentInUse(student: Student): Promise<boolean> {
    try {
      const isStudentInUse = await firstValueFrom(this.studentsService.isStudentInUse(student.account_id, student.id));

      if(isStudentInUse === true) {
        this.showMessage(`${globals.student_inuse} - ${student.account_name}`);
        this.loadingSpinner.emit(false);
        return true;
      }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      return true;
    }
  }

  private async isStudentsInUse(): Promise<boolean> {
    try {
      const student_ids = this.getSelectedStudentsIds();
      const accounts = await firstValueFrom(this.accountService.getAccountsInUse(student_ids));

      if(accounts?.length > 0) {
        const accounts_name = accounts.map(account => account.name).join();
        this.showMessage(`${globals.student_inuse} - ${accounts_name}`);
        this.loadingSpinner.emit(false);
        return true;
      }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      return true;
    }
  }

  private async isSameAccountFolderGroup(student: Student): Promise<boolean> {
    try {
      const accountsStudents = await firstValueFrom(this.accountService.getAccountsStudentsInUse([student.id]));

      if(accountsStudents?.length > 0) {
        this.showMessage(`${globals.students_duplicates} - ${student.account_name}`);
        this.loadingSpinner.emit(false);
        return true;
      }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      return true;
    }
  }

  private async isSameAccountFolderGroups(): Promise<boolean> {
    try {
      const student_ids = this.getSelectedStudentsIds();
      const accountsStudents = await firstValueFrom(this.accountService.getAccountsStudentsInUse(student_ids));

      if(accountsStudents?.length > 0) {
        const accounts_name = accountsStudents.map(row => `${row.account_name} : ${row.folder_name} : ${row.group_name}`).join();
        this.showMessage(`${globals.students_duplicates} - ${accounts_name}`);
        this.loadingSpinner.emit(false);
        return true;
      }

      const selectedStudentsFolders = await this.getSelectedStudentsFoldersGroups(true);
      const account_ids = this.getSelectedStudents().map(stu => stu.account_id);
      const uniqueAccountIds = account_ids.filter((n, i) => account_ids.indexOf(n) === i);
      const accountIds = uniqueAccountIds.map(acc => `'${acc}'`);
      const accountsFoldersInUse = await firstValueFrom(this.accountService.getAccountsFoldersInUse(accountIds));

      if(accountsFoldersInUse.length > 0) {
        selectedStudentsFolders.push(...accountsFoldersInUse);
      }

      const counts = selectedStudentsFolders.reduce((acc, item) => {
        acc[item] = (acc[item] || 0) + 1;
        return acc;
      }, {});

      const uniqueAccounts = selectedStudentsFolders.filter((n, i) => selectedStudentsFolders.indexOf(n) === i);
      const folder_limit_reference = Number(await firstValueFrom(this.configurationsService.getConnectEnvVariable('FoldersLimitInAccount')));

      const accountsFoldersLimitExceeded: string[] = [];

      uniqueAccounts.forEach(value => {
        const folder_limit = Number(counts[value]);

        if(folder_limit > folder_limit_reference) {
          accountsFoldersLimitExceeded.push(value);
        }
      });

      if(accountsFoldersLimitExceeded.length > 0) {
        const account_names = accountsFoldersLimitExceeded.join(' , ');
        this.showMessage(`${globals.folders_limit_exceeded} ${folder_limit_reference} - ${account_names}`);
        this.loadingSpinner.emit(false);
        return true;
      }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
      return true;
    }
  }

  private async isStudentsWithSameAccountFolderGroup(): Promise<boolean> {
    try {
      const resultsData = await this.getSelectedStudentsFoldersGroups();

      if(resultsData.length > 0) {
        const folders_groups_name = resultsData.map(row => `${row}`).join(' ');
        this.showMessage(`${globals.students_duplicates} - ${folders_groups_name}`);
        this.loadingSpinner.emit(false);

        return true;
      }

      return false;
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
      return true;
    }
  }

  private async getSelectedStudentsFoldersGroups(isFolderOnly: boolean = false): Promise<string[]> {

    const selectedStudents = this.getSelectedStudents();

    const selectedStudentsFolders = selectedStudents.map(s => isFolderOnly ? s.account_name : `${s.account_name} : ${s.folder_name} (Folder)`);
    const selectedStudentsFoldersGroups: string[] = [...selectedStudentsFolders];

    if(isFolderOnly) {
      return selectedStudentsFolders;
    }
    else {
      const selectedStudentsGroups = selectedStudents.map(s => `${s.account_name} : ${s.group_name} (${globals.GROUP})`);
      selectedStudentsFoldersGroups.push(...selectedStudentsGroups);
      
      const accountIds = selectedStudents.map(s => s.account_id);
      const uniqueAccountIds = accountIds.filter((n, i) => accountIds.indexOf(n) === i);
      const data = {
        account_ids: uniqueAccountIds,
        student_ids: this.getSelectedStudentsIds()
      };
      const existingStudents = await firstValueFrom(this.accountService.getAccountsStudentsAssign(data));
      const existingStudentsFolders = existingStudents.map(sf => `${sf.account_name} : ${sf.folder_name} (${globals.FOLDER})`);
      const existingStudentsGroups = existingStudents.map(sg => `${sg.account_name} : ${sg.group_name} (${globals.GROUP})`);
      
      selectedStudentsFoldersGroups.push(...existingStudentsFolders);
      selectedStudentsFoldersGroups.push(...existingStudentsGroups);
      
      const setData = new Set();
      const duplicatesData = selectedStudentsFoldersGroups.filter((item) => setData.has(item) || !setData.add(item));
      const resultsData = Array.from(new Set(duplicatesData));
      return resultsData;
    }
  }

  private InUse():boolean {
    const selectedStudents = this.getSelectedStudents();
    const InUse = selectedStudents.filter(student => 
      student.status === Status.InUse && student.cds_status === Status.InUse);

    if(InUse.length > 0) {
      this.showMessage(globals.students_assigned);
      this.loadingSpinner.emit(false);
      return true;
    }

    return false;
  }

  private IsUnassigned(): boolean {
    const selectedStudents = this.getSelectedStudents();
    const Unassigned = selectedStudents.filter(student => 
      (student?.status === Status.Unassigned) && (student?.cds_status === Status.Unassigned));
    
    if(Unassigned?.length > 0) {
      this.showMessage(globals.students_inuse);
      this.loadingSpinner.emit(false);
      return true;
    }

    return false;
  }

  private updateEmailId(student: Student) {
    this.retrieveTrainings(false);

    this.student = student;
    this.sidenaveditstudent.open();
  }

  private resendInvite(student: Student) {
    this.loadingSpinner.emit(true);
    this.retrieveTrainings(false);

    if(student.status === Status.Unassigned || student.status === Status.ErrorAssign) {
      this.showMessage(globals.reset_backfill_date_validation);
      this.loadingSpinner.emit(false);
      return;
    }

    try {
      this.connectService.resendInvite(student.id).subscribe({
        next: (data) => {
          this.showMessage(data ? globals.resend_invite_success : globals.resend_invite_failed);
          this.loadingSpinner.emit(false);
        },
        error: (e) => {
          this.showMessage(globals.resend_invite_failed);
          this.loadingSpinner.emit(false);
        }
      });
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner.emit(false);
    }
  }

  private async resetBackfillDate() {
    try {
      this.loadingSpinner.emit(true);
      await this.retrieveTrainingsAsync(false);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          dialogTitle: globals.RESET_BACKFILL_DATE,
          description: globals.RESET_BACKFILL_CONFIRM,
          cautionaryMessage: '',
          okButtonTitle: 'Reset',
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        try {
          const students = this.getSelectedStudentsIds();
          const reset_status = await firstValueFrom(this.studentsService.resetBackfillDate(students));

          this.showMessage(reset_status ? globals.reset_backfill_date_success : globals.reset_backfill_date_failed);
          this.loadingSpinner.emit(false);
          this.retrieveTrainings(true);
        }
        catch (exception) {
          this.logger.logException(exception);
          this.showMessage(globals.reset_backfill_date_failed);
          this.loadingSpinner.emit(false);
        }
      }
      else {
        this.loadingSpinner.emit(false);
      }
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  loadingStudentSpinner = (value: boolean) => this.loadingSpinner.emit(value);

  private isAssignTraining = (student: Student): boolean => (this.assign_status.includes(student?.status as Status));

  private isSetupTraining = (student: Student): boolean => {
    if (this.isDataHubEnabled) {
      if ((student.status === Status.Assigned && student.cds_status === Status.Unassigned) ||
      (student.status === Status.Error && student.cds_status === Status.Unassigned) ||
      (student.status === Status.InUse && student.cds_status === Status.Unassigned) ||
      (student.status === Status.InUse && student.cds_status === Status.Error)) {
        return true;
      }
      return false;
    }
    return (student.status === Status.Assigned || student.status === Status.Error);
  };

  private isSetupTrainingView = (student: Student): boolean => (this.setup_status.includes(student?.status as Status) || student?.cds_status === Status.Creating);

  private isCleanupTraining = (student: Student): boolean => {
    if ((student.status === Status.ErrorAssign && student.cds_status === Status.Unassigned) ||
    (student.status === Status.Error && student.cds_status === Status.Unassigned) ||
    (student.status === Status.InUse && student.cds_status === Status.Unassigned) ||
    (student.status === Status.InUse && student.cds_status === Status.Error) ||
    (student.status === Status.InUse && student.cds_status === Status.InUse)) {
      return true;
    }
    return false;
  };

  private isCleanupTrainingView = (student: Student): boolean => this.isView(student);

  private isDeleteStudent = (student: Student): boolean => ((student.status === Status.Unassigned && student.cds_status === Status.Unassigned) || student.status === Status.Error);

  private isDeleteStudentView = (student: Student): boolean => this.isView(student);

  private isStreamOnStudent = (student: Student): boolean => (student.cds_status === Status.InUse && student.stream_status === Status.Off);

  private isStreamOnStudentView = (student: Student): boolean => (student.stream_status === Status.Streaming);

  private isStreamOffStudent = (student: Student): boolean => (student.stream_status === Status.On);

  private isStreamOffStudentView = (student: Student): boolean => (student.stream_status === Status.Off);

  private isForceDeleteStudentView = (student: Student): boolean => (student.status !== Status.Unassigned || student.cds_status !== Status.Unassigned);

  private isAssignStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isNotUnassign = selectedStudents.filter(student => !this.isAssignTraining(student)).length;

    return (selectedStudents.length >=1 && isNotUnassign === 0);
  };

  private isSetupStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isNotUnassign = selectedStudents.filter(student => !this.isSetupTraining(student)).length;

    return (selectedStudents.length >=1 && isNotUnassign === 0);
  };

  private isCleanupStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isNotUnassign = selectedStudents.filter(student => !this.isCleanupTraining(student)).length;

    return (selectedStudents.length >=1 && isNotUnassign === 0);
  };

  private isStreamOnStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isNotInUse = selectedStudents.filter(student => student.cds_status !== Status.InUse || student.stream_status === Status.On).length;

    return (selectedStudents.length >=1 && isNotInUse === 0);
  };

  private isStreamOffStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isOff = selectedStudents.filter(student => student.stream_status === Status.Off).length;

    return (selectedStudents.length >=1 && isOff === 0);
  };

  private isBackfillStudentViews = () => {
    const selectedStudents = this.getSelectedStudents();
    const isOffStudents = selectedStudents.filter(student => student.cds_status === Status.InUse && student.stream_status === Status.Off).length;

    return (selectedStudents.length > 0 && selectedStudents.length === isOffStudents);
  };

  private getSelectedStudents = () => {
    const selectedStudents = this.selection.selected.filter(student => !this.isCheckBoxView(student));
    return selectedStudents;
  };

  private isCheckBoxView = (row: Student) => this.isView(row);

  private isView = (student: Student) => (this.view_status.includes(student.status as Status) || this.view_status.includes(student.cds_status as Status));
  
  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 8000 });

  // Define variables and objects
  hasBackdrop: boolean;
  isContributor: boolean;
  currentIndex = -1;
  studentsLength = 0;
  selection = new SelectionModel<Student>(true, []);
  currentStudent: Student = {};
  assign_status = [Status.Unassigned,Status.ErrorAssign];
  status = [Status.Assigned,Status.Error];
  setup_status = [Status.ErrorAssign,Status.Assigning,Status.Creating,Status.Unassigned];
  cds_status = [Status.Assigned,Status.Unassigned,Status.Error];
  clean_status = [Status.Assigned,Status.InUse,Status.ErrorAssign,Status.Error];
  view_status = [Status.Assigning,Status.Creating,Status.Cleaning];
  dataSource = new MatTableDataSource<Student>();
  student: Student;
  
  @Input() class_id = 0;
  @Input() isDataHubEnabled = false;

  get displayedColumns(): string[] {
    if (this.isDataHubEnabled) {
      return globals.trainingList_columns;
    }
    return globals.trainingList_columns.filter(col => col !== 'cds_status' && col !== 'stream_status');
  }
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  dialogRef: MatDialogRef<ImportErrorsComponent>;
  @ViewChild('sidenaveditstudent') sidenaveditstudent: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
